import { useState } from 'react';
import axios from 'axios';
import config from '../config';

const WorkerList = ({ workers, onDeleted }) => {
  const [showModal, setShowModal] = useState(false);
  const [workerToDelete, setWorkerToDelete] = useState(null);

  const confirmDelete = (w) => {
    setWorkerToDelete(w);
    setShowModal(true);
  };

  const deleteWorker = async () => {
    if (!workerToDelete) return;

    await axios.delete(
      `${config.API_BASE_URL}${config.ADMIN.DELETE_WORKER(workerToDelete.workerID)}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      }
    );

    setShowModal(false);
    setWorkerToDelete(null);
    onDeleted && onDeleted();
  };

  return (
    <div style={panel}>
      <h3>Matched Workers</h3>

      {workers.map(w => (
        <div key={w.workerID} style={row}>
          <span>
            {w.firstName} {w.lastName}
          </span>

          <button
            style={deleteBtn}
            onClick={() => confirmDelete(w)}
          >
            ✖
          </button>
        </div>
      ))}

      {showModal && (
        <div style={modalOverlay}>
          <div style={modalContent}>
            <h3>Delete Worker?</h3>
            <p>Are you sure you want to permanently delete {workerToDelete?.firstName}?</p>
            <div style={{ display: 'flex', gap: '10px', marginTop: '20px' }}>
              <button style={cancelBtn} onClick={() => setShowModal(false)}>Cancel</button>
              <button style={confirmBtn} onClick={deleteWorker}>Delete</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const panel = { padding:20, background:'#fff' };
const row = {
  display:'flex',
  justifyContent:'space-between',
  padding:8,
  borderBottom:'1px solid #ddd'
};
const deleteBtn = {
  background:'red',
  color:'#fff',
  border:'none',
  cursor:'pointer',
  borderRadius: '4px',
  padding: '4px 8px'
};

const modalOverlay = {
  position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
  background: 'rgba(0,0,0,0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000
};
const modalContent = {
  background: '#fff', padding: '24px', borderRadius: '8px', minWidth: '300px', textAlign: 'center'
};
const cancelBtn = {
  flex: 1, padding: '8px', cursor: 'pointer', border: '1px solid #ccc', borderRadius: '4px', background: '#f9f9f9'
};
const confirmBtn = {
  flex: 1, padding: '8px', cursor: 'pointer', border: 'none', borderRadius: '4px', background: 'red', color: '#fff'
};

export default WorkerList;
